import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Field, getFormValues, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';

import FormButton from '../FormButton';
import DataValue from '../../components/DataValue';
import dateFormat from "date-fns/format";
import HelpChat from '../../components/HelpChat';

import 'react-datepicker/dist/react-datepicker.css';

import {
	renderFieldText, renderFieldRadio, renderFieldPhone, renderFieldDatePicker
	//  renderFieldSelect
} from '../Form/renderField';
import {
	v_required,
	n_phone,
	// v_cf_2,
	v_email,
	v_vat_number_length,
	v_vat_number_length_2,
	v_sdi_length,
	n_onlychar,
	n_onlyalfa_special,
	n_cf_length,
	n_vat_number,
	n_vat_number_generic,
	n_emailchar,
	n_sdi_code
} from '../Form/checkField';

import { onSubmitFail } from '../../utils/commonFormsHandlers';
import { HELPER_TIMEOUT, personTypeOptions, defaultPersonType } from '../../utils/commonFormsConfig';
// import { getCountries } from './utils';
import { FORM_STEP2 } from '../Form/actionCreator';

import { getHasProfile } from '../App/selectors';
import subYears from 'date-fns/subYears';
// import { updatedFetch } from '../../utils/fetch/actionCreators';


class Step2 extends Component {
	state = {
		openHelpChat: false
	};

	componentDidMount() {
		// const { updatedFetch } = this.props;
		setTimeout(() => {
			this.setState({ openHelpChat: true });
		}, HELPER_TIMEOUT);
	}


	handleMobilePhoneSelect = (prefix) => {
		const { change } = this.props;
		change('mobilePhone1Prefix', prefix);
	};

	handlePhoneSelect = (prefix) => {
		const { change } = this.props;
		change('phone1Prefix', prefix);
	};

	render() {
		const { handleSubmit, valuesStep2, t, hasProfile, i18n } = this.props;
		const { openHelpChat } = this.state;

		const values = valuesStep2 ? valuesStep2.toJS() : {};
		const callGAEventsCondition = values['authComunicazioniPromo'];

		const isIta = values.country && values.country.value === 'IT' ? true : false;

		const yearsToRemove = 18;

		// const countries = getCountries(t);

		return <div className='px-lg-4'>
			<form onSubmit={handleSubmit} noValidate>
				{
					!hasProfile ? <div className='row'>
						<div className='form-group col-md-12 mb-4'>
							<Field name='personType' label={t('form.step2.personType')} options={personTypeOptions} component={renderFieldRadio} forceInline={true} required={true} validate={[(value) => v_required(value, t)]} />
						</div>
					</div> : ''
				}
				<div className='row'>
					<div className='form-group col-md-6 mb-4'>
						{
							hasProfile ? <Fragment>
								<label>{t('form.step2.firstName')}</label>
								<DataValue value={values.firstName}></DataValue>
							</Fragment> :
								<Field name='firstName' label={t('form.step2.firstName')} component={renderFieldText} required={true} validate={[(value) => v_required(value, t)]} normalize={n_onlychar} />
						}
					</div>
					<div className='form-group col-md-6 mb-4'>
						{
							hasProfile ? <Fragment>
								<label>{t('form.step2.lastName')}</label>
								<DataValue value={values.lastName}></DataValue>
							</Fragment> :
								<Field name='lastName' label={t('form.step2.lastName')} component={renderFieldText} required={true} validate={[(value) => v_required(value, t)]} normalize={n_onlychar} />
						}
					</div>
					<div className='form-group col-md-6 mb-4'>
						<Field name='phone1' label={t('form.step2.phone1')} component={renderFieldPhone} change={this.handlePhoneSelect} i18n={i18n} normalize={n_phone} />
					</div>
					<div className='form-group col-md-6 mb-4'>
						<Field name='mobilePhone1' label={t('form.step2.mobilePhone1')} component={renderFieldPhone} change={this.handleMobilePhoneSelect} i18n={i18n} required={true} normalize={n_phone} />
					</div>
					{hasProfile ? <>
						<label>{t('form.step2.dateOfBirth')}</label>
						<DataValue value={dateFormat(values.dataDiNascita, "dd/MM/yyyy")}></DataValue>
					</> : <div className='form-group col-md-6 mb-4'>
						<Field name='dataDiNascita' label={t('form.step2.dateOfBirth')} component={renderFieldDatePicker} maxDate={subYears(new Date(), yearsToRemove)} required={true} validate={[(value) => v_required(value, t)]} />
					</div>}
				</div>
				{
					values.personType === '2' && <Fragment>
						<div className='row'>
							<div className='col'>
								<h4 className='mb-2'>{t('form.step2.subtitle_1')}</h4>
							</div>
						</div>

						<div className='row'>
							<div className='form-group col-md-6 mb-4'>
								{
									hasProfile ? <Fragment>
										<label>{t('form.step2.rappresentanteLegaleNome')}</label>
										<DataValue value={values.rappresentanteLegaleNome}></DataValue>
									</Fragment> :
										<Field name='rappresentanteLegaleNome' label={t('form.step2.rappresentanteLegaleNome')} component={renderFieldText} required={true} validate={[(value) => v_required(value, t)]} normalize={n_onlychar} />
								}
							</div>
							<div className='form-group col-md-6 mb-4'>
								{
									hasProfile ? <Fragment>
										<label>{t('form.step2.rappresentanteLegaleCognome')}</label>
										<DataValue value={values.rappresentanteLegaleCognome}></DataValue>
									</Fragment> :
										<Field name='rappresentanteLegaleCognome' label={t('form.step2.rappresentanteLegaleCognome')} component={renderFieldText} required={true} validate={[(value) => v_required(value, t)]} normalize={n_onlychar} />
								}
							</div>
						</div>

						<div className='row'>
							<div className='col'>
								<h4 className='mb-2'>{t('form.step2.subtitle_2')}</h4>
							</div>
						</div>
						<div className='row'>
							<div className='form-group col-md-6 mb-4'>
								{
									hasProfile ? <Fragment>
										<label>{t('form.step2.ragioneSociale')}</label>
										<DataValue value={values.ragioneSociale}></DataValue>
									</Fragment> :
										<Field name='ragioneSociale' label={t('form.step2.ragioneSociale')} component={renderFieldText} required={true} validate={[(value) => v_required(value, t)]} normalize={n_onlyalfa_special} />
								}
							</div>
						</div>
						<div className='row'>
							<div className='form-group col-md-6 mb-4'>
								{
									hasProfile ? <Fragment>
										<label>{t('form.step2.partitaIva')}</label>
										<DataValue value={values.partitaIva}></DataValue>
									</Fragment> :
										<Field name='partitaIva' label={t('form.step2.partitaIva')} component={renderFieldText} required={true} validate={isIta ? [(value) => v_required(value, t), (value) => v_vat_number_length(value, t)] : [(value) => v_required(value, t)]} normalize={isIta ? n_vat_number : n_vat_number_generic} />
								}
							</div>
							<div className='form-group col-md-6 mb-4'>
								{
									hasProfile ? <Fragment>
										<label>{t('form.step2.codiceFiscaleAzienda')}</label>
										<DataValue value={values.codiceFiscaleAzienda}></DataValue>
									</Fragment> :
										<Field name='codiceFiscaleAzienda' label={t('form.step2.codiceFiscaleAzienda')} component={renderFieldText} required={true} validate={[(value) => v_required(value, t), (value) => v_vat_number_length_2(value, t)]} normalize={n_cf_length} />
								}
							</div>
							<div className='form-group col-md-6'>
								{
									hasProfile ? <Fragment>
										<label>{t('form.step2.pec')}</label>
										<DataValue value={values.pec}></DataValue>
									</Fragment> :
										<Field name='pec' label={t('form.step2.pec')} component={renderFieldText} validate={[(value) => v_email(value, t)]} normalize={n_emailchar} />
								}
							</div>
							<div className='form-group col-md-6 mb-4'>
								{
									hasProfile ? <Fragment>
										<label>{t('form.step2.codiceSDI')}</label>
										<DataValue value={values.codiceSDI}></DataValue>
									</Fragment> :
										<Field name='codiceSDI' label={t('form.step2.codiceSDI')} component={renderFieldText} required={true} validate={[(value) => v_required(value, t), (value) => v_sdi_length(value, t)]} normalize={n_sdi_code} />
								}
							</div>
						</div>
					</Fragment>
				}

				<FormButton {...this.props} callGAEvents={callGAEventsCondition}></FormButton>
			</form>
			{openHelpChat && <HelpChat />}
		</div>;
	}
}

const defaultValues = {
	personType: defaultPersonType
};

const mapStateToProps = (state) => {
	return {
		initialValues: defaultValues,
		valuesStep2: getFormValues(FORM_STEP2)(state),
		hasProfile: getHasProfile(state)
	};
};

const mapDispatchToProps = {};

Step2.propTypes = {
	initialValues: PropTypes.object,
	valuesStep2: PropTypes.object,
	change: PropTypes.func,
	handleSubmit: PropTypes.func,

	hasProfile: PropTypes.bool,
	i18n: PropTypes.object,
	t: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
	form: FORM_STEP2, // a unique name for this form
	destroyOnUnmount: false,
	onSubmitFail: (errors) => {
		onSubmitFail(errors);
	},
	validate: (values, props) => {
		values = values.toJS();

		const errors = {};
		// controllo mobile
		if (!values.mobilePhone1) {
			errors.mobilePhone1 = props.t('form.validation.required');
			return errors;
		}
		if (values.mobilePhone1Prefix) {
			const prefix = values.mobilePhone1Prefix.slice(1);
			if (prefix !== "") {
				if ((values.mobilePhone1.length - prefix.length) < 6) { // eslint-disable-line
					errors.mobilePhone1 = props.t('form.validation.required');
					return errors;
				}
			}
		}
		return errors;
	}
	// asyncValidate,
	// keepDirtyOnReinitialize: true,
	// enableReinitialize: true
	// validate,   // <--- validation function given to redux-form
	// warn        // <--- warning function given to redux-form
})(Step2));
